// client/src/services/errorReporter.js
import API from './api';

/**
 * إرسال تقرير خطأ إلى الخادم
 * @param {Error} error - كائن الخطأ
 * @param {Object} context - معلومات سياقية إضافية (مثل userId, matchId, component)
 */
export const reportError = async (error, context = {}) => {
    try {
        await API.post('/errors/report', {
            message: error.message || 'Unknown error',
            stack: error.stack || '',
            context,
            url: window.location.href,
            userAgent: navigator.userAgent,
            severity: 'error',
        });
    } catch (reportErr) {
        // في حال فشل إرسال التقرير، نسجل في console فقط لتجنب حلقة لا نهائية
        console.warn('⚠️ Failed to report error:', reportErr);
    }
};

/**
 * إعداد مصائد الأخطاء العالمية (window.onerror, unhandledrejection)
 */
export const setupGlobalErrorHandler = () => {
    // التقاط الأخطاء غير المتوقعة في الـ JavaScript
    window.onerror = (message, source, lineno, colno, error) => {
        reportError(error || new Error(message), {
            source,
            line: lineno,
            column: colno,
        });
        // نعيد false لئلا نحجب الخطأ عن المتصفح
        return false;
    };

    // التقاط الـ Promises التي لم يتم التعامل مع رفضها
    window.addEventListener('unhandledrejection', (event) => {
        reportError(event.reason, {
            type: 'unhandledrejection',
        });
    });

    //console.log('✅ Global error handler initialized');
};